const _throttle = require('lodash.throttle');

let resizeListenerAdded = false;

function initializeDynamicColumns() {
    const dynamicColumnPanels = document.querySelectorAll('.faq-panel.grid,.people-panel.grid,.accordion-panel.grid');

    dynamicColumnPanels.forEach(dynamicColumnPanel => {
        const dynamicColumns = {
            1: dynamicColumnPanel.querySelector('[data-dynamic-column="1"]'),
            2: dynamicColumnPanel.querySelector('[data-dynamic-column="2"]'),
            3: dynamicColumnPanel.querySelector('[data-dynamic-column="3"]'),
            4: dynamicColumnPanel.querySelector('[data-dynamic-column="4"]')
        };

        function distributeDynamicCards() {
            const dynamicCards = Array.from(dynamicColumnPanel.querySelectorAll('[data-dynamic-card-index]'));

            // Sort Dynamic cards by data-dynamic-card-index
            dynamicCards.sort((a, b) => parseInt(a.dataset.dynamicCardIndex) - parseInt(b.dataset.dynamicCardIndex));

            // Distribute Dynamic cards based on media queries
            const windowWidth = window.innerWidth;

            if (windowWidth < 640) {
                dynamicCards.forEach(card => {
                    dynamicColumns[1].appendChild(card);
                });
            } else if (windowWidth >= 640 && windowWidth < 1024) {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 2) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            } else if (windowWidth >= 1024 && windowWidth < 1279) {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 3) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            } else {
                dynamicCards.forEach((card, index) => {
                    const columnNumber = (index % 4) + 1;
                    dynamicColumns[columnNumber].appendChild(card);
                });
            }
        }

        const throttledDistributeDynamicCards = _throttle(distributeDynamicCards, 200);

        // Add resize listener only once
        if (!resizeListenerAdded) {
            window.addEventListener('resize', () => {
                const windowWidth = window.innerWidth;

                // Check if media query actually changes
                if ((windowWidth < 640 && window.prevWidth >= 640) ||
                    (windowWidth >= 640 && windowWidth < 1024 && (window.prevWidth < 640 || window.prevWidth >= 1024)) ||
                    (windowWidth >= 1024 && windowWidth < 1280 && (window.prevWidth < 1024 || window.prevWidth >= 1280)) ||
                    (windowWidth >= 1280 && window.prevWidth < 1280)) {
                    throttledDistributeDynamicCards();
                }
                window.prevWidth = windowWidth;
            });
            resizeListenerAdded = true;
        }

        // Initial distribution of Dynamic cards
        distributeDynamicCards();
    });
}

// Run on both DOMContentLoaded and window load
document.addEventListener('DOMContentLoaded', initializeDynamicColumns);
window.addEventListener('load', initializeDynamicColumns);
